import React from 'react';
import nutriscoreA from '../assets/nutriscore/nutriscore-a.svg';
import nutriscoreB from '../assets/nutriscore/nutriscore-b.svg';
import nutriscoreC from '../assets/nutriscore/nutriscore-c.svg';
import nutriscoreD from '../assets/nutriscore/nutriscore-d.svg';
import nutriscoreE from '../assets/nutriscore/nutriscore-e.svg';
import ecoscoreA from '../assets/ecoscore/green-score-a.svg';
import ecoscoreB from '../assets/ecoscore/green-score-b.svg';
import ecoscoreC from '../assets/ecoscore/green-score-c.svg';
import ecoscoreD from '../assets/ecoscore/green-score-d.svg';
import ecoscoreE from '../assets/ecoscore/green-score-e.svg';
import novaGroup1 from '../assets/nova/nova-group-1.svg';
import novaGroup2 from '../assets/nova/nova-group-2.svg';
import novaGroup3 from '../assets/nova/nova-group-3.svg';
import novaGroup4 from '../assets/nova/nova-group-4.svg';

const HowItWorksSection: React.FC = () => {
    return (
    <div id="how-it-works-section" className="bg-gray-50 py-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-gray-900 mb-4" data-aos="fade-up">Comment fonctionne Le Panier Clair</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="100">
                        Commencer est simple et ne prend que quelques secondes.
                    </p>
                </div>
                
                <div className="grid md:grid-cols-3 gap-8">
                    <div className="flex flex-col items-center text-center" data-aos="fade-up">
                        <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-md">
                            <span className="text-2xl font-bold text-green-600">1</span>
                        </div>
                        <h3 className="text-xl font-bold mb-3">Installez l’extension</h3>
                        <p className="text-gray-600">
                            Ajoutez Le Panier Clair à votre navigateur Chrome, Firefox ou Edge en un clic.
                        </p>
                    </div>
                    
                    <div className="flex flex-col items-center text-center" data-aos="fade-up" data-aos-delay="100">
                        <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-md">
                            <span className="text-2xl font-bold text-green-600">2</span>
                        </div>
                        <h3 className="text-xl font-bold mb-3">Faites vos courses comme d’habitude</h3>
                        <p className="text-gray-600">
                            Rendez-vous sur vos sites de courses en ligne préférés et naviguez normalement.
                        </p>
                    </div>
                    
                    <div className="flex flex-col items-center text-center" data-aos="fade-up" data-aos-delay="200">
                        <div className="bg-white w-20 h-20 rounded-full flex items-center justify-center mb-6 shadow-md">
                            <span className="text-2xl font-bold text-green-600">3</span>
                        </div>
                        <h3 className="text-xl font-bold mb-3">Voyez les notes instantanément</h3>
                        <p className="text-gray-600">
                            Les badges NutriScore, NOVA et EcoScore apparaissent automatiquement à côté des produits.
                        </p>
                    </div>
                </div>
                
                <div className="mt-16 bg-white rounded-xl shadow-md overflow-hidden" data-aos="zoom-in">
                    <div className="md:flex">
                        <div className="md:flex-shrink-0">
                            <img className="h-full w-full object-cover md:w-96" src="http://static.photos/technology/1024x576/1" alt="Extension en action" />
                        </div>
                        <div className="p-8">
                            <div className="uppercase tracking-wide text-sm text-green-600 font-semibold mb-1">Démo</div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Voyez l’extension en action</h3>
                            <p className="text-gray-600 mb-6">
                                Notre extension ajoute des badges clairs et colorés aux listes de produits pour que vous puissiez rapidement évaluer leur qualité nutritionnelle, leur degré de transformation et leur impact environnemental.
                            </p>
                            <div className="flex flex-col gap-4">
                                <div>
                                    <div className="text-xs text-gray-500 mb-2">NutriScore</div>
                                    <div className="flex space-x-1">
                                        <img src={nutriscoreA} alt="NutriScore A" className="h-8" />
                                        <img src={nutriscoreB} alt="NutriScore B" className="h-8" />
                                        <img src={nutriscoreC} alt="NutriScore C" className="h-8" />
                                        <img src={nutriscoreD} alt="NutriScore D" className="h-8" />
                                        <img src={nutriscoreE} alt="NutriScore E" className="h-8" />
                                    </div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500 mb-2">EcoScore</div>
                                    <div className="flex space-x-1">
                                        <img src={ecoscoreA} alt="EcoScore A" className="h-8" />
                                        <img src={ecoscoreB} alt="EcoScore B" className="h-8" />
                                        <img src={ecoscoreC} alt="EcoScore C" className="h-8" />
                                        <img src={ecoscoreD} alt="EcoScore D" className="h-8" />
                                        <img src={ecoscoreE} alt="EcoScore E" className="h-8" />
                                    </div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500 mb-2">NOVA</div>
                                    <div className="flex space-x-1">
                                        <img src={novaGroup1} alt="NOVA 1" className="h-8" />
                                        <img src={novaGroup2} alt="NOVA 2" className="h-8" />
                                        <img src={novaGroup3} alt="NOVA 3" className="h-8" />
                                        <img src={novaGroup4} alt="NOVA 4" className="h-8" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorksSection;